import { useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"

import { closeModal } from "src/store/ui"
import { selectCityModalOpen, selectAttackModalOpen, selectCityModalSeq } from "./selectors"

import ModalService from "src/modals"

const UIWatcher = () => {
  const dispatch = useDispatch()

  const cityModalOpen = useSelector(selectCityModalOpen)
  const cityModalSeq = useSelector(selectCityModalSeq)
  const attackModalOpen = useSelector(selectAttackModalOpen)

  // Reconcile the flags with what is actually on screen rather than reacting to edges only: if a
  // flag says open and no such modal is in the stack, show it. The two can drift — ModalHost
  // remounting, a hide that skipped onClose — and an edge-only watcher then ignores every later
  // request because the flag "did not change".
  useEffect(() => {
    if (attackModalOpen && !ModalService.isShowing("AttackModal")) {
      ModalService.show("AttackModal", {
        onClose: () => {
          dispatch(closeModal("AttackModal"))
        },
      })
    } else if (cityModalOpen && !attackModalOpen && !ModalService.isShowing("CityModal")) {
      ModalService.show("CityModal", {
        onClose: () => dispatch(closeModal("CityModal")),
      })
    }
  }, [cityModalOpen, cityModalSeq, attackModalOpen, dispatch])

  return null
}

export default UIWatcher
